




















import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {OutOfStockShopItem} from "@/modules/models";

@Component
export default class OutOfStockDialog extends CommonBase {
  @Prop({ default: null })
  value!: OutOfStockShopItem | null;

  get opened() {
    return this.value !== null;
  }

  set opened(value: boolean) {
    if (!value) {
      this.$emit("input", undefined);
    }
  }

  close() {
    this.opened = false;
  }
}
